import { isEmpty } from 'lodash';

const getRequestApprovalTypeResponse = (response) => {
  if (isEmpty(response?.data?.list)) return [];

  return response?.data?.list?.map((type) => {
    return {
      id: type?.id,
      value: type?.id?.toString(),
      label: type?.name,
    };
  });
};

export default getRequestApprovalTypeResponse;
